// extracted by mini-css-extract-plugin
export default {"container":"ExchangeSelect_container__ykG+d"};